import styled from 'styled-components';
import { Form } from '@unform/web';

export const Formulario = styled(Form)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1rem;

  width: 95%;
  margin: 1rem;
`;

export const CampoConteiner = styled.div`
  display: flex;
  gap: 1rem;

  width: 100%;
`;

export const ConteinerBotoes = styled.div`
  display: flex;
  align-self: flex-end;
`;
